"use strict";
import React from "react";
import { Close, IconSize, Warning } from "../../icons";
import classNames from "classnames";
import { observer } from "mobx-react";
import { IconButton } from "../../..";
import { ButtonSize, ButtonTheme, ButtonType } from "../Button/Button";
export var AlertAlignment = /* @__PURE__ */ ((AlertAlignment2) => {
  AlertAlignment2["Left"] = "left";
  AlertAlignment2["Center"] = "center";
  return AlertAlignment2;
})(AlertAlignment || {});
export var AlertType = /* @__PURE__ */ ((AlertType2) => {
  AlertType2["Info"] = "info";
  AlertType2["Error"] = "error";
  return AlertType2;
})(AlertType || {});
export var AlertTheme = /* @__PURE__ */ ((AlertTheme2) => {
  AlertTheme2["Light"] = "light";
  AlertTheme2["Dark"] = "dark";
  return AlertTheme2;
})(AlertTheme || {});
const DefaultErrorIcon = /* @__PURE__ */ React.createElement("div", { className: "alert__icon-warning" }, /* @__PURE__ */ React.createElement(Warning, null));
const Alert = observer(
  ({
    heading,
    headingIcon,
    children,
    alignment = "left" /* Left */,
    alertType = "info" /* Info */,
    className,
    theme = "light" /* Light */,
    onDismiss
  }) => /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classNames("alert", className, {
        "alert--centre-aligned": alignment === "center" /* Center */,
        "alert--error-type": alertType === "error" /* Error */,
        "alert--theme-dark": theme === "dark" /* Dark */
      }),
      role: alertType === "error" /* Error */ ? "alert" : void 0
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames("alert__heading", {
          "alert__heading--theme-dark": theme === "dark" /* Dark */,
          "alert__heading--dismissable": !!onDismiss
        })
      },
      (alertType === "error" /* Error */ || headingIcon) && /* @__PURE__ */ React.createElement("div", { className: "alert__icon" }, headingIcon || DefaultErrorIcon),
      heading,
      onDismiss && /* @__PURE__ */ React.createElement("div", { className: "alert__dismiss" }, /* @__PURE__ */ React.createElement(
        IconButton,
        {
          className: "alert__dismiss-button",
          onClick: onDismiss,
          icon: /* @__PURE__ */ React.createElement(Close, { size: IconSize.Small }),
          size: ButtonSize.Small,
          type: ButtonType.Tertiary,
          "aria-label": "Dismiss alert",
          theme: theme === "dark" /* Dark */ ? ButtonTheme.Dark : void 0
        }
      ))
    ),
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames("alert__body", {
          "alert__body--error-type": alertType === "error" /* Error */,
          "alert__body--centre-aligned": alignment === "center" /* Center */,
          "alert__body--theme-dark": theme === "dark" /* Dark */
        })
      },
      children
    )
  )
);
export { Alert };
